"use strict";import{defineElement as e}from"@spectrum-web-components/base/src/define-element.js";import{Textfield as t}from"./src/Textfield.js";e("sp-textfield",t);
//# sourceMappingURL=sp-textfield.js.map
